<div [@routerTransition]>
  <!--<div class="row row-style-card">
    <a (click)="AddNewPatient()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here for New Registration"><i class="fas fa-plus font-size-11 margin-right-3px"></i>New Cycle</a>
    <a class="nav-link-hand new-button3" title="Back To Profile" (click)="BackToProfile()" *ngIf="Showarrow"><i class="fas fa-angle-double-left font-size-19px"></i> Patient List</a>
  </div>-->

  <div class="row">
    <div class="col-md-12">
      <div class="card my-profile-form margin-top-20px" *ngIf="ShowList">
        <div class="card-header bk-lt-gray wh-header padding-bottom-6px padding-left-13px">
          <div class="row">
            <div class="col-md-3">
              Treatment Cycles
            </div>
            <div class="col-md-8 padding-right-0px">
              <!--<div class="col-md-3 float-right padding-right-0px">
      <input type="text" class="form-control" placeholder="Search" (input)="criteriaChange($event.target.value)">
    </div>-->
              <!--<div class="row">
      <div class="offset-md-6 col-md-2 text-align-right padding-right-0px padding-left-0px padding-right-0px">
        <a (click)="SearchPatient()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px font-weight-normal" title="Click here for New Registration"><i class="fas fa-plus font-size-11 margin-right-3px"></i>New Cycle</a>
      </div>
      <div class="col-md-4 float-right padding-left-0px padding-right-0px">
        <form novalidate="" #f="ngForm" class="display-inherit">
          <input type="text" class="form-control" placeholder="Search" [(ngModel)]="searchValue" name="searchBar" [value]='searchValue'>
          <button (click)="criteriaChange(searchValue)" class="btn font-size-13px actions-btn-prime margin-right-auto margin-left-5px">Go</button>
        </form>
      </div>
    </div>-->

              <div class="row">
                <div class="offset-md-6 col-md-2 padding-right-0px text-align-center">
                  <a *canUserAccess="['HL_IVF_4']" (click)="SearchPatient()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here for New Cycle"><i class="fas fa-plus font-size-11 margin-right-3px"></i>New Cycle</a>
                </div>
                <div class="col-md-4 float-right padding-right-0px padding-l-0px display-inherit">
                  <form novalidate="" #f="ngForm" class="display-inherit">
                    <div class="clear-form">
                      <input type="text" class="form-control" placeholder="Search" [(ngModel)]="searchValue" name="searchBar" [value]='searchValue' maxlength="15">
                      <a (click)="ClearInput()" class="nav-link-hand" title="Clear" *ngIf="searchValue!=null"><span class="clear-icon"><i class="fa fa-times"></i></span></a>
                    </div>
                    <!--<input type="text" class="form-control" placeholder="Search" [(ngModel)]="searchValue" name="searchBar" [value]='searchValue' maxlength="15">-->
                    <button (click)="criteriaChange(searchValue)" class="btn font-size-13px actions-btn-prime margin-right-auto margin-left-5px">Go</button>
                  </form>
                </div>
              </div>
            </div>
            <div class="col-md-1">
              <button type="button" class="btn  btn-raised  broder-primary margin-right-5px  button-Schedule font-size-14p padding-left-6px padding-right-6px padding-top-3px border-all-0px" (click)="DisplayStyle('List')"><i class="fas fa-list"></i></button>
              <button type="button" class="btn  btn-raised  broder-primary   button-Schedule font-size-18px padding-left-6px padding-right-6px padding-top-3px border-all-0px" (click)="DisplayStyle('Card')"><i class="fas fa-id-badge"></i></button>
            </div>
          </div>

        </div>
        <div class="card-body padding-top-0px">

          <div class="row">
            <!--<div class="margin-top-180px">
              <a class="nav-link-hand  back-link" title="Back To Profile" (click)="BackToTreatment()"><i class="fas fa-angle-double-left font-size-19px"></i></a>
            </div>-->
            <div class="col-md-12 padding-right-0px">
              <div class="table-component" *ngIf="ShowListView">
                <div class="table-responsive overflow-x">


                  <table class="table table-striped width-100pe margin-left-zero"
                         cols="auto,2*,*,*,*,*,*,*">

                    <thead class="">
                      <tr>

                        <th class="">
                          PID
                        </th>
                        <!--<th class="text-align-center">Day</th>-->
                        <th class="">
                          Cycle#
                        </th>

                        <th class="padding-left-4">
                          Name
                        </th>
                        <!--<th class="text-align-center">Start Time</th>-->




                        <th class="">
                          Contact
                        </th>
                        <th class="padding-left-9px">
                          Sex &amp; Age
                        </th>

                        <th></th>
                        <th>Protocol</th>
                        <th>Prtcl Start Date</th>
                        <th class="padding-left-10px">Cycle Type</th>
                        <th>Duration</th>
                        <!--<th>Cmp.Status</th>-->
                        <th>Comp.Status</th>
                        <th></th>
                        <th hidden></th>


                      </tr>
                    </thead>

                    <tbody class="table-body">
                      <tr *ngFor="let l of CurrentTreatmentCyclesController">

                        <td class="td-padding-tb padding-top-0px padding-bottom-0px padding-right-0px">
                        <a (click)="ViewPatientDetails(l)" class="nav-link-hand">
                          <i class="far fa-folder-open margin-right-3px folder-color"></i> {{l.PatientRegNo}}</a>  </td>
                        <!--<td class="td-padding text-align-center">Mon</td>-->
                        <td class=" padding-top-0px padding-bottom-0px text-align-right ">
                          {{l.CycleNo}}
                        </td>
                        <td class="td-padding padding-top-0px padding-bottom-0px ">
                          {{l.DisplayName}}
                        </td>
                        <td class=" td-padding-tb padding-top-0px padding-bottom-0px">{{l.Telephone1}}</td>
                        <!--<td class="td-padding text-align-center"></td>-->
                        <td class=" td-padding-tb padding-top-0px padding-bottom-0px">{{l.Gender}} &amp; {{l.Age}}</td>

                        <td class=" td-padding-tb padding-top-0px padding-bottom-0px">{{l.TCModelName}}</td>
                        <td class="td-padding-tb padding-top-0px padding-bottom-0px">{{l.ProtocolName}}</td>
                        <td class="td-padding-tb padding-top-0px padding-bottom-0px">{{l.ProtocolStartDate| date:'MMM-dd-yyyy'}}</td>
                        <td class="td-padding-tb padding-top-0px padding-bottom-0px ">{{l.CycleType}}</td>
                        <td class=" td-padding-tb padding-top-0px padding-bottom-0px">{{l.Duration}} days</td>
                        <td class="padding-top-0px padding-bottom-0px">{{l.CompletedStatus}}</td>
                        <td class="padding-top-0px padding-bottom-0px">
                          <div class="display-inline" *canUserAccess="['EditCycle']">
                            <a class="nav-link-hand education-navlink" tooltip="Edit" (click)="EditCycleDetails(l)">
                              <span class="badge font-size-12px"><i class="fas fa-pencil-alt"></i></span>
                            </a>
                          </div>
                          <div class="display-inline" *canUserAccess="['DeleteCycle']">
                            <a class="nav-link-hand font-size-12px color-Rejected" title="Remove" (click)="DeleteCycle(l)">
                              <i class="far fa-trash-alt nav-link-hand"></i>
                            </a>
                          </div>
                        </td>
                        <!--<td class="padding-top-0px padding-bottom-0px">{{l.RecordStatus}}</td>-->
                        <td hidden class="td-padding-tb padding-top-0px padding-bottom-0px">
                          <button (click)="UpdateStatus(l)" class="btn actions-btn-prime font-size-13px">Update Status </button>

                        </td>



                      </tr>

                    </tbody>

                  </table>
                </div>
              </div>

              <div *ngIf="!ShowListView" class="row">
                <div class="col-md-2 padding-top-6px" *ngFor="let l of CurrentTreatmentCyclesController; let RowIndex = index ">

                  <div class=" card  height-100pe profile-card-border border-effect">
                    <div class="card-body padding-left-0px padding-right-0px padding-top-0px padding-bottom-0px margin-left-0px">


                      <div class="">
                        <div class="row margin-left-0px margin-right-0px padding-top-5px">
                          <div class="col-md-12 text-align-center">
                            <h4 class="margin-bottom-0px  font-size-12px margin-left-3px font-weight-bold text-align-center">{{l.CycleType}}</h4>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12 text-align-center padding-top-5px padding-left-0px padding-right-0px">
                            <img class="img-circle-50" [src]='l.PatientImageFile' onError="this.src='dummy.jpg';">
                            <!--<img src="dummy.jpg" class="nav-link-hand image-width-catalogue padding-top-5px padding-bottom-5px" />-->
                          </div>
                        </div>
                        <div class="row margin-left-3px margin-right-0px padding-top-5px">
                          <div class="col-md-12">
                            <h4 class="margin-bottom-0px  font-size-20px margin-left-3px font-weight-bold text-align-center">{{l.DisplayName}}</h4>
                          </div>

                        </div>
                        <div class="row margin-left-3px margin-right-0px padding-bottom-10px">
                          <div class="col-md-12">
                            <h4 class="margin-bottom-0px color-#999999 font-size-12px margin-left-3px font-weight-normal text-align-center">{{l.PatientRegNo}}</h4>
                          </div>

                        </div>

                      </div>

                      <div class="background-color-wt">

                        <div class="row margin-right-0px padding-top-15px">
                          <div class="col-md-4 padding-left-0px padding-right-0px">
                            <h4 class="margin-bottom-0px  font-size-12px margin-left-3px font-weight-bold text-align-center">{{l.Age}}</h4>
                          </div>
                          <div class="col-md-4 padding-left-0px padding-right-0px">
                            <h4 class="margin-bottom-0px  font-size-12px margin-left-3px font-weight-bold text-align-center">{{l.Gender}}</h4>
                          </div>
                          <div class="col-md-4 padding-left-0px padding-right-0px">
                            <h4 class="margin-bottom-0px  font-size-12px font-weight-bold text-align-center">{{l.ProtocolStartDate| date:'MMM-dd-yyyy'}}</h4>
                          </div>
                        </div>
                        <div class="row margin-right-0px">
                          <div class="col-md-4 padding-left-0px padding-right-0px">
                            <h4 class="margin-bottom-0px  font-size-10px margin-left-3px font-weight-normal text-align-center">Age</h4>
                          </div>
                          <div class="col-md-4 padding-left-0px padding-right-0px">
                            <h4 class="margin-bottom-0px  font-size-10px margin-left-3px font-weight-normal text-align-center">Sex</h4>
                          </div>
                          <div class="col-md-4 padding-left-0px padding-right-0px">
                            <h4 class="margin-bottom-0px  font-size-10px font-weight-normal text-align-center">Start</h4>
                          </div>
                        </div>
                        <div class="row margin-left-5px margin-right-5px">
                          <div class="col-md-12 bk-lt-gray padding-right-0px padding-left-0px text-align-center">
                            <label class="margin-bottom-0px font-size-14px font-weight-bold">
                              {{l.CompletedStatus}}
                            </label>
                          </div>
                        </div>
                        <div class="row margin-left-3px margin-right-0px padding-top-5px padding-bottom-0px">

                          <div class="col-md-8 text-align-right  nav-link-hand" (click)="ViewPatientDetails(l)">
                            <i class="far fa-folder-open circle-icon" data-toggle="tooltip" data-placement="bottom" title="Open"></i>
                            <!--<button (click)="ViewPatientDetails(l)" class="btn font-size-10px actions-btn-prime-profile margin-right-auto margin-left-5px">View...</button>-->
                          </div>
                          <div hidden class="col-md-6 text-align-left  nav-link-hand" (click)="UpdateStatus(l)">
                            <i class="far fa-folder-open circle-icon2" data-toggle="tooltip" data-placement="bottom" title="Close Cycle...(X)"></i>
                            <!--<button (click)="ViewPatientDetails(l)" class="btn font-size-10px actions-btn-prime-profile margin-right-auto margin-left-5px">View...</button>-->
                          </div>

                        </div>
                      </div>
                    </div>

                  </div>



                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
<div class="col-md-12" *ngIf="!ShowList">

  <treatmentCycle2 (GoBack)="OnGoBack()" [ActorCode]='SelectedPatient.ActorCode'
                   [CycleCode]='SelectedPatient.Code' [Duration]='SelectedPatient.Duration'
                   [GradingModel]='SelectedPatient.GradingModel' *ngIf="ShowPatientDetails"></treatmentCycle2>
</div>
